import { Component, OnInit, Input, OnDestroy, HostListener, ElementRef, ViewChild } from '@angular/core';
import { CourseViewModel, CourseEventStatus, PlayheadLocationModel } from 'src/app/_models/generatedModels';
import { Subscription, combineLatest, of, interval } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/_services/generatedServices';
import { Title } from '@angular/platform-browser';
import { delay, tap } from 'rxjs/operators';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CeuAssessmentComponent } from './ceu-assessment/ceu-assessment.component';
import { AnalyticsService } from 'src/app/_services/analytics.service';

declare var zE: any;
declare var flowplayer: any;
import { Flowplayer, FPEvent } from "@flowplayer/player";
import Player = Flowplayer.Player;
import { EventRole } from "../../_models/models";

@Component({
  selector: 'bxl-course-viewer',
  templateUrl: 'course-viewer.component.html',
})
export class CourseViewerComponent implements OnInit, OnDestroy {
  initialized = false;
  private routeSubscription: Subscription;
  showAssessment = false;
  showMaterials = false;
  availible = false;

  livePlayer: Player;
  @ViewChild('fullscreenContainer') fullscreenContainer: ElementRef;
  public isFullScreen: boolean;
  course: CourseViewModel;
  id: any;

  CourseEventStatus = CourseEventStatus;
  notAuthorized = false;
  timerSubcription: Subscription;
  currentTime: number;
  playHeadLocation: PlayheadLocationModel;
  preview: boolean;
  cc: boolean;

  constructor(private route: ActivatedRoute, private modalService: NgbModal, private router: Router, private auth: AuthenticationService, private toaster: ToasterService, private titleService: AnalyticsService, private courseData: CourseService) {}

  ngOnInit(): void {
    let root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    root.setAttribute('class', 'hideScrollBars');

    this.routeSubscription = combineLatest(this.route.data, this.route.paramMap, this.route.queryParamMap).subscribe(([data, params, queryParams]) => {
      this.id = params.get('id');
      this.preview = queryParams.get('preview') === 'true';

      if (queryParams.has('cc')) {
        this.cc = queryParams.get('cc') ? queryParams.get('cc').toLocaleLowerCase() === 'true' : false;
      }

      this.courseData.getSpecificCourse(this.id).subscribe(
        (course) => {
          this.courseData.getPLayheadLocation(course.id).subscribe((playhead) => {
            this.playHeadLocation = playhead;
            this.course = course;
            if (!this.course.userHasPurchased && !this.auth.isSuperUser()) {
              this.router.navigate(['courses', this.course.slug]);
              return;
            }
            this.availible = course.courseEventStatus.toString() === CourseEventStatus[CourseEventStatus.Published].toString() || course.courseEventStatus.toString() === CourseEventStatus[CourseEventStatus.PublishedInternal].toString() || course.courseEventStatus.toString() === CourseEventStatus[CourseEventStatus.NotForSale].toString() || course.courseEventStatus.toString() === CourseEventStatus[CourseEventStatus.Unlisted].toString() || (course.courseEventStatus.toString() === CourseEventStatus[CourseEventStatus.ReleaseWithConference].toString() && course.released && this.course.encoded && this.course.userHasPurchased);

            if (this.preview === true && this.auth.isSuperUser()) {
              this.availible = true;
            }

            this.titleService.setTitleAndLogPageView('View Course - ' + course.title);
            this.initialized = true;
            if (this.availible) {
              this.initializePlayer();
            }
          });
        },
        (error) => {
          this.notAuthorized = true;
          this.initialized = true;
        }
      );
    });
    this.loadZendesk();

    //this.toaster.messageDialog("Please watch the video in its entirety, and once its done, click 'CEUs' at the bottom to take the quiz and get your certificate!", 'CEU Instructions').subscribe();
  }

  initializePlayer() {
    of(true)
      .pipe(
        delay(500),
        tap(() => {
          this.setupPlayer();
        })
      )
      .subscribe();
  }

  CEUClicked() {
    if (!this.course.assessmentId) {
      this.toaster.messageDialog('This presenter has not provided CEU questions yet. You can watch the recording now and complete the assessment later once the presenter has uploaded their assessment.', 'Missing Assessment').subscribe();
      return;
    }

    const modalRef = this.modalService.open(CeuAssessmentComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });
    modalRef.componentInstance.course = this.course;

    modalRef.result.then(
      (result) => {},
      (reason) => {}
    );
    return;
  }

  setupPlayer() {
    this.livePlayer = flowplayer('#wowzaPlayer', {
      qsel: {
        labels: [],
      },
      src: this.course.wowzaPlaybackUrl,
      autoplay: flowplayer.autoplay.AUDIO_REQUIRED,
      ui: flowplayer.ui.NO_FULLSCREEN,
      disabled: true,
      // seekable:false,
      token: "eyJraWQiOiIwWE44RnRTYkQxblYiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6MzgsXCJpZFwiOlwiMFhOOEZ0U2JEMW5WXCJ9IiwiaXNzIjoiRmxvd3BsYXllciJ9.wHlyQZ86rIHD8ldgnpiWbmFBmR4zt_3FSj78GMk7lfQ1es7K8y0MuHzbqcJfp0lm6LcUbUkQ5PsazIsAybxivg"
    });

    // (this.livePlayer.setOpts({seekable:false}))


    // var parent = this;
    // this.livePlayer.on(['seeking'], function (e) {
    //   // e.type is the event type such as "seeking"
    //   var type = e.type
    //   console.log('seeking');
    //   console.log(e);
    //   e.stopPropagation();
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    //   return false;
    //   //parent.livePlayer.currentTime = parent.playHeadLocation.playheadLocationMax;
    // })

    this.livePlayer.currentTime = this.playHeadLocation.playheadLocation;

    const callback = interval(120000);
    this.timerSubcription = callback.subscribe(() => {
      if (!this.livePlayer) {
        return;
      }

      console.log('Updating Playhead: ' + this.livePlayer.currentTime);
      this.courseData.updatePlayhead(this.course.id, Math.floor(this.livePlayer.currentTime)).subscribe();
      this.playHeadLocation.playheadLocation = this.livePlayer.currentTime;
      this.playHeadLocation.playheadLocationMax = Math.max(this.livePlayer.currentTime, this.playHeadLocation.playheadLocationMax);
    });

    this.livePlayer.emit(flowplayer.events.SET_QUALITY, {level: 0})
  }

  //
  // setupPlayer2() {
  //   let source = { src: this.course.azureAssetId, type: 'video/mp4' };
  //   let preroll = {
  //     sourceUri: '/preroll.xml',
  //     options: {
  //       skipAd: {
  //         enabled: true,
  //         offset:5
  //       },
  //     },
  //   };
  //
  //   if (this.preview) {
  //     preroll = null;
  //   }
  //
  //   console.log(source);
  //
  //   let options: any = {
  //     autoplay: true,
  //     controls: true,
  //     hotKeys: {
  //       enableVolumeScroll: false,
  //     },
  //     fluid: true,
  //     logo: { enabled: false },
  //   };
  //
  //   if (this.cc) {
  //     console.log('cc enabled');
  //     options.imsc1CaptionsSettings = [{ label: 'English', srclang: 'en', enabled: 'false' }];
  //     options.ampAds = {
  //       mainProgram: {
  //         source: source,
  //       },
  //     };
  //   } else {
  //     options.ampAds = {
  //       preRoll: preroll,
  //       mainProgram: {
  //         source: source,
  //       },
  //     };
  //   }
  //
  //   this.livePLayer = amp('livePLayer', options);
  //   this.livePLayer.src([{ src: this.course.azureAssetId, type: 'application/vnd.ms-sstr+xml' }]);
  //
  //   this.livePLayer.addEventListener('start', (evt) => {
  //     this.livePLayer.currentTime(this.playHeadLocation.playheadLocation);
  //   });
  //
  //   this.livePLayer.addEventListener('ended', (evt) => {
  //     console.log(evt);
  //     console.log('completed playing');
  //   });
  //
  //   // if (!this.auth.isSuperUser()) {
  //   //   this.livePLayer.addEventListener('seeking', (evt) => {
  //   //     if (this.livePLayer.currentTime() < 60) {
  //   //       return;
  //   //     }
  //   //     if (this.livePLayer.currentTime() > this.playHeadLocation.playheadLocationMax + 5) {
  //   //       this.livePLayer.currentTime(this.playHeadLocation.playheadLocationMax);
  //   //     }
  //   //   });
  //   // }
  //
  //   const callback = interval(120000);
  //   this.timerSubcription = callback.subscribe(() => {
  //     if (!this.livePLayer) {
  //       return;
  //     }
  //
  //     console.log('Updating Playhead: ' + this.livePLayer.currentTime());
  //     this.courseData.updatePlayhead(this.course.id, Math.floor(this.livePLayer.currentTime())).subscribe();
  //     this.playHeadLocation.playheadLocation = this.livePLayer.currentTime();
  //     this.playHeadLocation.playheadLocationMax = Math.max(this.livePLayer.currentTime(), this.playHeadLocation.playheadLocationMax);
  //   });
  // }

  loadZendesk() {
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });
  }

  techSupportClicked() {
    zE('webWidget', 'show');
    zE('webWidget', 'open');
  }

  exitPage() {
    if (this.preview) {
      this.router.navigate(['/super-user/courses']);
      return;
    }

    this.courseData.getCourseUserCompletionStatus(this.course.id).subscribe((result) => {
      if (result.metCEUCriteria) {
        this.router.navigate(['/account/library']);
        return;
      } else {
        this.toaster.confirmDialog('You have not completed the CEU assessment. Are you sure you want to leave this course without getting CEUs?<br><br> To get CEUs, click "CEUs" at the bottom of the screen.', 'Exit without CEUs?', 'Yes, Exit', 'Cancel').subscribe((result) => {
          if (result) {
            this.router.navigate(['/account/library']);
          }
        });
      }
    });
  }

  toggleCaptions() {
    if (this.cc) {
      (<any>window).location = '/on-demand/' + this.course.slug;
      //his.window.location =.navigate(['/live-events/484/live'], { queryParams: { cc: false }, queryParamsHandling: 'merge' });
    } else {
      (<any>window).location = '/on-demand/' + this.course.slug + '?cc=true';
      //this.router.navigate(['/live-events/484/live'], { queryParams: { cc: true }, queryParamsHandling: 'merge' });
    }
  }

  fullscreen() {
    let elem = this.fullscreenContainer.nativeElement;
    let doc = <any>document;
    if (!this.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      setTimeout(() => {
        this.isFullScreen = true;
      }, 500);
    } else {
      if (document.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        /* Firefox */
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        /* IE/Edge */
        doc.msExitFullscreen();
      }

      of(null)
        .pipe(delay(500))
        .subscribe((result) => {
          this.isFullScreen = false;
        });
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  exit(ev) {
    if (this.isFullScreen) {
      of(null)
        .pipe(delay(3000))
        .subscribe((result) => {
          this.isFullScreen = false;
          console.log('exiting');
        });
    }
  }

  ngOnDestroy(): void {
    let root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    root.removeAttribute('class');

    console.log('disposing');
    if (this.livePlayer) {
      console.log('disposed media player');
      this.livePlayer.destroy();
    }

    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }

    if (this.timerSubcription) {
      this.timerSubcription.unsubscribe();
    }
  }

  protected readonly EventRole = EventRole;
}
